module.exports = __webpack_public_path__ + "img/drivesafe.a1bfc4cb.jpg";